import { validate as validateEmail } from 'email-validator';

export const isPhoneE164 = value => !!value.match(/^\+[1-9]\d{1,14}$/);
export const isPhoneE164OrEmpty = value => isPhoneE164(value) || value === '';

export const isPhoneNumberValidWithDialCode = (value, dialCode = '') => {
  const phoneNumber = value.startsWith(dialCode)
    ? value
    : `${dialCode}${value}`;
  const sanitizedNumber = phoneNumber.replace(/^\+/, ''); // Remove '+' for validation

  return !!sanitizedNumber.match(/^[1-9]\d{4,14}$/); // Validate the phone number with minimum 5 digits and maximum 15 digits
};

export const isPhoneNumberValidIsraeliLandline = value => {
  const phoneNumber = value.replace(/-/g, '');

  const shouldFormatAsIsraeliLandline =
    phoneNumber.startsWith('0') &&
    (phoneNumber.length === 9 || phoneNumber.length === 10);
  const israeliLandlineNumber = shouldFormatAsIsraeliLandline
    ? `972${phoneNumber.slice(1)}`
    : phoneNumber;
  return !!israeliLandlineNumber.match(/^[1-9]\d{10,11}$/); // Validate israeli landline phone number with minimum 11 digits and maximum 12 digits
};

export const startsWithPlus = value => value.startsWith('+');

export const shouldBeUrl = (value = '') =>
  value ? value.startsWith('http') : true;

export const isValidPassword = value => {
  const containsUppercase = /[A-Z]/.test(value);
  const containsLowercase = /[a-z]/.test(value);
  const containsNumber = /[0-9]/.test(value);
  const containsSpecialCharacter = /[!@#$%^&*()_+\-=[\]{}|'"/\\.,`<>:;?~]/.test(
    value
  );
  return (
    containsUppercase &&
    containsLowercase &&
    containsNumber &&
    containsSpecialCharacter
  );
};

export const isNumber = value => /^\d+$/.test(value);

export const isDomain = value => {
  if (value !== '') {
    const domainRegex = /^([\p{L}0-9]+(-[\p{L}0-9]+)*\.)+[a-z]{2,}$/gmu;
    return domainRegex.test(value);
  }
  return true;
};

export const hasMoreSpaceBetweenWords = (value, length) =>
  !!value.match(new RegExp('\\s{' + length + ',}'));

export const arabicLettersRegex = /^[\u0600-\u06FF]+$/;
export const hebrewLettersRegex = /^[\u0590-\u05FF]+$/;
export const alphanumericUnderscoreRegex = /^[a-z0-9_]+$/;
export const alphaNumHyphenUnderscoreRegex = /^[\p{L}\p{N}\-_]+$/u;

export const isEmailValidOrEmpty = value =>
  value ? validateEmail(value) : true;

export const isPath = path => path.startsWith('/') && path.length > 1;
